import { Box, useScaleFactor } from "arkh";
import { GraphLabel, WidgetTaskSingleGraphOccasion } from "../Graph/Graph";
import React, { useMemo, useState } from "react";

import { GoalHorizontalBar } from "./GoalDisplay";
import { NumberBar } from "./NumberBar";
import { formatValue } from "./formatNumber";

export type GraphNumberData = {
  id: string;
  label: string;
  value: number | null;
  isActive?: boolean;
  parts?: { color?: string; weight: number }[];
}[];

export const GraphNumber = React.memo(GraphNumberC);

function GraphNumberC(props: {
  goals: {
    value: number;
    mode: "GT" | "LT";
    label?: string | undefined;
  }[];
  data: GraphNumberData;
  animated?: boolean;
}) {
  const [totalGraphBarHeight, setGraphBarHeight] = useState(0);
  const sf = useScaleFactor();
  const graphBarHeight = totalGraphBarHeight - 40 * sf;
  const historyMax = useMemo(
    () => Math.max(...props.data.map((h) => h.value ?? 0)),
    [props.data]
  );

  const graphHighestNumber = Math.max(
    historyMax,
    ...props.goals.map(({ value }) => value)
  );

  return (
    <Box
      spaceLeft={props.goals.length > 0 ? "xlarge" : "none"}
      style={{
        flexDirection: "row",
        height: "100%",
        width: "100%",
        flex: 1,
        position: "relative",
      }}
      onLayout={(e) => {
        setGraphBarHeight(e.nativeEvent.layout.height);
      }}
    >
      <GoalHorizontalBar
        totalHeight={graphBarHeight}
        maxVal={graphHighestNumber}
        bars={props.goals}
        animated={props.animated}
      />
      {props.data.map(({ id, label, value, isActive, parts }) => (
        <WidgetTaskSingleGraphOccasion key={id}>
          <NumberBar
            formatedVal={
              formatValue("CUSTOM", value ?? undefined)[0](value) +
              (formatValue("CUSTOM", value ?? undefined)[1] ?? "")
            }
            isActive={isActive ?? false}
            val={value}
            totalHeight={graphBarHeight}
            maxVal={graphHighestNumber}
            parts={parts}
          />

          <GraphLabel children={label} active={isActive} />
        </WidgetTaskSingleGraphOccasion>
      ))}
    </Box>
  );
}
